<template>
  <div class="c-loading-content">
    <div class="c-loading-content__overlay"></div>
    <Loading />
  </div>
</template>

<script lang="ts">
export default {};
</script>
